import { Paso } from './Paso';

export class PasoVideo extends Paso {
  constructor() {
    super(
      false,
      'Placa de Video',
      `El procesador gráfico de una tarjeta es muchísimo más potente que el que tienen los procesadores, por esta razón es necesaria para el buen
      funcionamiento del equipo y muy recomendada para gamers y profesionales de los gráficos.`,
      5,
      'gpu.png',
      'gpu.png',
      true,
      [],
      '',
    );
  }
}
